/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const SlackIcon = ({
  className,
  style: propStyles,
  color = '#3A50F3',
  onClick,
  size,
  version = '1',
}: IconTypeProps & { version?: '1' | '2' }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    ...propStyles,
  };

  if (version === '2') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
        className={classNames(className)}
        onClick={onClick}
      >
        <path
          d="M2.62455 7.87813C2.64018 7.19531 2.7808 6.53281 3.04486 5.90938C3.31518 5.26875 3.70268 4.69531 4.19643 4.2C4.69018 3.70469 5.26518 3.31719 5.9058 3.04688C6.5683 2.76719 7.27143 2.625 7.99799 2.625C8.72455 2.625 9.42768 2.76719 10.0886 3.04688C10.7274 3.31663 11.3075 3.70831 11.7964 4.2C11.9511 4.35469 12.0964 4.51875 12.2308 4.69063L11.2902 5.425C11.2716 5.4394 11.2574 5.45875 11.2493 5.48085C11.2412 5.50294 11.2395 5.52687 11.2444 5.54988C11.2493 5.5729 11.2606 5.59406 11.277 5.61094C11.2934 5.62783 11.3142 5.63974 11.3371 5.64531L14.0824 6.31719C14.1605 6.33594 14.2371 6.27656 14.2371 6.19688L14.2496 3.37031C14.2496 3.26562 14.1292 3.20625 14.048 3.27187L13.1667 3.96094C11.9652 2.42344 10.0964 1.4375 7.99643 1.4375C4.41674 1.4375 1.50424 4.30625 1.43705 7.87187C1.43663 7.88855 1.43956 7.90514 1.44565 7.92067C1.45175 7.9362 1.46089 7.95035 1.47254 7.96229C1.48419 7.97423 1.49811 7.98372 1.51348 7.9902C1.52886 7.99667 1.54537 8.00001 1.56205 8H2.49955C2.5683 8 2.62299 7.94531 2.62455 7.87813ZM14.4371 8H13.4996C13.4308 8 13.3761 8.05469 13.3746 8.12187C13.3589 8.80469 13.2183 9.46719 12.9542 10.0906C12.6839 10.7312 12.2964 11.3063 11.8027 11.8C11.3043 12.3004 10.7118 12.6972 10.0594 12.9675C9.40688 13.2379 8.70736 13.3763 8.00111 13.375C7.2951 13.3763 6.59582 13.2378 5.94361 12.9675C5.2914 12.6972 4.69918 12.3004 4.20111 11.8C4.04643 11.6453 3.90111 11.4812 3.76674 11.3094L4.70736 10.575C4.72597 10.5606 4.74014 10.5412 4.74824 10.5192C4.75634 10.4971 4.75804 10.4731 4.75314 10.4501C4.74825 10.4271 4.73695 10.4059 4.72056 10.3891C4.70417 10.3722 4.68335 10.3603 4.66049 10.3547L1.91518 9.68281C1.83705 9.66406 1.76049 9.72344 1.76049 9.80313L1.74955 12.6313C1.74955 12.7359 1.86986 12.7953 1.95111 12.7297L2.83236 12.0406C4.03393 13.5766 5.90268 14.5625 8.00268 14.5625C11.5839 14.5625 14.4949 11.6922 14.5621 8.12813C14.5625 8.11145 14.5595 8.09486 14.5534 8.07933C14.5474 8.0638 14.5382 8.04965 14.5266 8.03771C14.5149 8.02577 14.501 8.01628 14.4856 8.0098C14.4702 8.00333 14.4537 7.99999 14.4371 8Z"
          fill="#262626"
        />
      </svg>
    );
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86627 2C6.98182 2.00065 6.26603 2.71698 6.26668 3.59966C6.26603 4.48235 6.98248 5.19868 7.86693 5.19933H9.46718V3.60032C9.46783 2.71763 8.75138 2.0013 7.86627 2C7.86693 2 7.86693 2 7.86627 2V2ZM7.86627 6.26664H3.60025C2.7158 6.26729 1.99935 6.98362 2 7.86631C1.99869 8.74899 2.71515 9.46532 3.5996 9.46662H7.86627C8.75073 9.46597 9.46718 8.74965 9.46652 7.86696C9.46718 6.98362 8.75073 6.26729 7.86627 6.26664Z"
        fill="#36C5F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 7.86631C18.0006 6.98362 17.2842 6.26729 16.3997 6.26664C15.5153 6.26729 14.7988 6.98362 14.7995 7.86631V9.46662H16.3997C17.2842 9.46597 18.0006 8.74965 18 7.86631ZM13.7333 7.86631V3.59966C13.7339 2.71763 13.0181 2.0013 12.1337 2C11.2492 2.00065 10.5327 2.71698 10.5334 3.59966V7.86631C10.5321 8.74899 11.2485 9.46532 12.133 9.46662C13.0175 9.46597 13.7339 8.74965 13.7333 7.86631Z"
        fill="#2EB67D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1329 17.9999C13.0174 17.9992 13.7338 17.2829 13.7332 16.4002C13.7338 15.5175 13.0174 14.8012 12.1329 14.8005H10.5327V16.4002C10.532 17.2822 11.2485 17.9986 12.1329 17.9999ZM12.1329 13.7326H16.3996C17.2841 13.7319 18.0005 13.0156 17.9999 12.1329C18.0012 11.2502 17.2847 10.5339 16.4003 10.5326H12.1336C11.2491 10.5332 10.5327 11.2496 10.5333 12.1323C10.5327 13.0156 11.2485 13.7319 12.1329 13.7326Z"
        fill="#ECB22E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.1329C1.99935 13.0156 2.7158 13.7319 3.60026 13.7326C4.48471 13.7319 5.20117 13.0156 5.20052 12.1329V10.5332H3.60026C2.7158 10.5339 1.99935 11.2502 2 12.1329ZM6.2667 12.1329V16.3996C6.26539 17.2823 6.98185 17.9986 7.86631 17.9999C8.75076 17.9992 9.46722 17.2829 9.46656 16.4002V12.1342C9.46787 11.2515 8.75142 10.5352 7.86696 10.5339C6.98185 10.5339 6.26605 11.2502 6.2667 12.1329C6.2667 12.1329 6.2667 12.1335 6.2667 12.1329Z"
        fill="#E01E5A"
      />
    </svg>
  );
};
